<template>
  <div @click="onClose" id="modal_wrap">
    <div class="modal_container">
      <div class="swal2-header">
        <div class="swal2-icon swal2-info swal2-animate-info-icon" style="display: flex;"></div>
      </div>
      <div class="modal_header">
        <h3>{{ modalData.header }}</h3>
      </div>
      <div class="modal_body">

        <div class="flex align-items-center">
          <DrugSearchNew
            class="flex-grow-1"
            ref="selectedDrug"
            :searchOptions="{getPrices: true}"
            :onDrugSelect="(d) => {}"/>
          <div><input type="number" class="form-control" v-model="newQty"></div>
          <div>
            <button @click="addNewDrug" class="btn fs-18 btn-outline-success m-0"><i class="icon-fa icon-fa-plus"/>
            </button>
          </div>
        </div>

        <div v-for="(drug, index) in localDrugs" class="p-b-10" v-if="!drug.toDelete">
          <div class="adjustable_flex">
            <!--            <drugSearch-->
            <!--              ref="selectedDrug"-->
            <!--              :drugSelected="drug"-->
            <!--              :enableQty="true"-->
            <!--              :getPrice="{siteId: 1}"-->
            <!--              :updateDrug="updateDrugs"-->
            <!--            />-->
            <div class="flex justify-content-between align-items-center">
              <div>{{ drug.new_drug.title }} x {{ drug.qty }} x <strong>{{ drug.price }}</strong></div>
              <div>
                <button @click="deleteDrug(drug.drug_id)" class="btn btn-outline-danger btn-xs"><i
                  class="icon-fa icon-fa-trash"/></button>
              </div>
            </div>
            <div class="flex mt-1">
              <div class="input-group mr-1">
                <div v-if="modalData.rate && modalData.rate != 1" class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">руб.</span>
                </div>
                <input disabled type="text" v-model="drug.price" class="form-control price_field ">
              </div>
              <div v-if="modalData.rate && modalData.rate != 1" class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon2">бел.р.</span>
                </div>
                <input v-if="modalData.rate && modalData.rate != 1" disabled type="text"
                       :value="Math.round(drug.price * modalData.rate * 10) / 10" class="form-control price_field ">
              </div>
            </div>
          </div>
        </div>

        <div class="text-right">
          <p>Итого (стоимость перепаратов): <span><strong>{{ totalPrice }}</strong> руб.</span> <span
            v-if="modalData.rate && modalData.rate != 1"> / <strong>{{
              Math.round(totalPrice * modalData.rate * 10) / 10
            }}</strong> бел.р.</span>
          </p>
        </div>

        <div v-if="errorMessage">
          <p class="error_messages">{{ errorMessage }}</p>
        </div>
        <!--        <div>-->
        <!--          <button @click="addNewDrug" class="btn-xs btn btn-info">Добавить препарат</button>-->
        <!--        </div>-->

      </div>
      <div class="modal_actions">
        <vue-ladda @click="onAccept" button-class="btn btn-success"
                   data-style="zoom-in"
                   :loading="acceptBtnLoading">{{ modalData.acceptBtnText }}
        </vue-ladda>
        <button @click="onReject" class="btn btn-default">{{ modalData.cancelBtnText || 'Отмена' }}</button>
      </div>
      <div class="modal_footer"></div>
    </div>
  </div>
</template>

<script>

import VueLadda from 'vue-ladda/src/vue-ladda.vue'
import drugSearch from "../../drugs/drugSearch";
import DrugSearchNew from "@/components/drugs/DrugSearchNew.vue";

export default {
  components: {
    VueLadda,
    drugSearch,
    DrugSearchNew,
  },
  props: [
    'onModalClose', 'onModalAccept', 'modalData'
  ],
  data() {
    return {
      siteId: 1,
      newQty: 1,
      totalPrice: 0,
      localDrugs: null,
      acceptBtnLoading: false,
      errorMessage: null,
    }
  },
  mounted() {
    let drugs = [];
    this.modalData.drugs.forEach((d) => {
      d.qty = d.qty / d.pack_set;
      d.toDelete = false;
      // d.price = d.price;
      drugs.push(d);
    });
    this.localDrugs = [...drugs];
    this.updateTotalPrice();
  },
  methods: {
    deleteDrug(drugId) {
      const index = this.localDrugs.findIndex((d) => d.drug_id === drugId);
      if (this.localDrugs[index].id) {
        this.localDrugs[index].toDelete = true;
      } else {
        this.localDrugs = this.localDrugs.filter((d) => d.drug_id !== drugId);
      }
      this.updateTotalPrice();
    },
    getPriceByQty(drug) {
      if (drug.prices) {
        const prices = _.orderBy(drug.prices, 'qty', 'desc');
        let price = 0;
        prices.forEach((p) => {
          if (+p.site_id === +this.siteId && +drug.qty >= +p.qty && price === 0) price = p.price;
        })
        return price;
      }
      return drug.price;
    },
    updateDrugs() {
      // let drugs = this.collectDrugs();
      let drugs = [...this.localDrugs];
      drugs.forEach((d) => {
        d.price = this.getPriceByQty(d);
      })
      this.localDrugs = [...drugs];
      this.updateTotalPrice();
    },
    updateTotalPrice() {
      this.totalPrice = 0;
      this.localDrugs.forEach((d) => {
        if (d.toDelete) return;
        this.totalPrice += d.price * d.qty;
      })
    },
    collectDrugs(clear = true) {
      let drugs = [];
      let hasEmpty = false;
      this.$refs.selectedDrug.forEach((sd) => {
        if ((!sd.drug || !sd.drug.id) && !clear) {
          hasEmpty = true;
          return;
        }
        if (clear && sd.drug && sd.drug.id) {
          drugs.push(sd.drug);
        }
      })
      return clear ? drugs : hasEmpty;
    },
    addNewDrug() {
      const drug = this.$refs.selectedDrug.drug;
      if (!drug) return;
      const check = this.localDrugs.find((d) => d.drug_id === drug.id);
      if (check) return;
      this.localDrugs.push({
        drug_id: drug.id,
        qty: this.newQty,
        new_drug: drug,
        // prices: drug.prices,
        price: this.getPriceByQty({...drug, qty: +this.newQty}),
      });
      this.newQty = 1;
      this.updateTotalPrice();
      // let hasEmpty = this.collectDrugs(false);
      // if (!hasEmpty) {
      //   this.localDrugs.push({});
      // }
    },
    onAccept(e) {
      this.errorMessage = null;
      let err = false;
      // const drugs = this.collectDrugs();
      const drugs = [...this.localDrugs]
      let ids = {}
      drugs.forEach((d) => {
        if (err) return;
        if (ids[d.id]) {
          this.errorMessage = 'Дубликат препарата ' + d.title;
          err = true;
          return;
        }
        if (d.id && (!d.qty || d.qty <= 0)) {
          this.errorMessage = 'Препарат ' + d.title + ' без количества';
          err = true;
          return;
        }
        ids[d.id] = true;
      })

      if (err) return;
      this.acceptBtnLoading = true;
      this.onModalAccept(drugs)
    },
    onReject(e) {
      this.onModalClose();
    },
    onClose(e) {
      if (!this.acceptBtnLoading && e.target.id === 'modal_wrap' && !this.acceptBtnLoading) {
        this.onModalClose();
      }
    }
  }
}

</script>

<style>
</style>

<style scoped>

@media (max-width: 520px) {
  /*  .adjustable_flex {*/
  /*    display: block !important;*/
  /*  }*/
  /*.modal_container {*/
  /*  height: 100%;*/
  /*}*/
  /*#modal_wrap {*/
  /*  background-color: white!important;*/
  /*}*/
}

.adjustable_flex {
  /*display: flex;*/
  display: block;
}

.input-group-text {
  height: 34px;
}

.price_field {
  width: 90px;
  height: 34px;
}

.error_messages {
  color: red;
}

.btn-xs {
  font-size: 12px !important;
  padding: 3px 10px !important;
}

.btn {
  margin: 10px;
  padding: 7px 25px;
  font-size: 24px;
}

#modal_wrap {
  display: none;
  position: fixed;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.55);
  width: 100vw;
  height: 100vh;
  overflow: auto;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal_body {
  z-index: 1;
  justify-content: center;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 1.125em;
  font-weight: 400;
  line-height: normal;
  text-align: center;
  word-wrap: break-word;
}

.modal_header {
  position: relative;
  max-width: 100%;
  margin: 0 0 .4em;
  padding: 0;
  color: #595959;
  font-size: 1.875em;
  font-weight: 600;
  text-align: center;
  text-transform: none;
  word-wrap: break-word;
}

.modal_actions {
  display: flex;
  z-index: 1;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 1.25em auto 0;
}

.modal_container {
  background-color: white;
  padding: 20px;
  /*min-width: 500px;*/
  width: fit-content;
  max-height: 100%;
  overflow: auto;
}
</style>
